import { render, staticRenderFns } from "./LegacyBrowserBanner.vue?vue&type=template&id=6a99202c&"
import script from "./LegacyBrowserBanner.vue?vue&type=script&lang=ts&"
export * from "./LegacyBrowserBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports